import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR } from "@angular/forms";

export interface ToggleOption {
    value;
    label;
}

@Component({
    selector: 'app-setting-toggle-group',
    templateUrl: './setting-toggle-group.component.html',
    styleUrls: ['./setting-toggle-group.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SettingToggleGroupComponent),
            multi: true
        }
    ]
})
export class SettingToggleGroupComponent implements ControlValueAccessor {
    @Input() icon = '';
    @Input() title = '';
    @Input() name = '';
    @Input() ariaLabel = '';
    @Input() options: ToggleOption[] = [];
    @Input() hideSingleSelectionIndicator: boolean = false;

    @Output() selectionChange = new EventEmitter<string>();

    me = 'setting-toggle-group';
    private _value = '';
    private onChange = (value) => {};
    private onTouched = () => {};

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    onToggleChange(event: any) {
        const value = event.value;
        this.value = value;
        this.selectionChange.emit(value);
    }

    // ControlValueAccessor implementation
    writeValue(value): void {
        this._value = value;
    }

    registerOnChange(fn: (value) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }
}
